import React, { useState, useEffect } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles } from "@material-ui/styles";
import Iframe from "react-iframe";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import SvgIcon from "@material-ui/core/SvgIcon";
import Icon from "@material-ui/core/Icon";

import {
  Title,
  Paragraph,
  SubTitle,
  DocImage,
  DocImages,
  NavigateButton,
  DocPaper,
  DocLink,
  Panel,
  Text,
  TextButton,
  TabWithContent,
  useDynamicImage,
  SimpleGallery,
} from "../DocCreater";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: "10px",
    right: "10px",
    margin: theme.spacing(1),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

//本文档的引用图片存放的位置
const imageFolder = "/images/intropage/";

//介绍视频
const IntroVideo = (props) => {
  const { videoUrl } = props;
  return (
    <div
      style={{
        display: "block",
        height: "43.2vw",
        width: "76.8vw",
        overflow: "hidden",
        margin: "auto",
      }}
    >
      <Iframe url={videoUrl} width="100%" height="100%" allowFullScreen />
    </div>
  );
};

//评审账号说明
const AccountPanel = (props) => {
  const onlineSupportRoot = "http://qgssupport.pkugujian.com/";
  return (
    <>
      <Paragraph>
        <Text color="secondary">
          访问实验模块需登录，评审账号：testStudent 密码：qgsTest002
        </Text>
      </Paragraph>
      <Paragraph></Paragraph>
      <Paragraph>
        实验已完成与实验空间的技术接口对接，也可使用实验空间账号密码登录本实验。
      </Paragraph>

      <Paragraph>
        通过点击上方导航栏的"构件认知"、"实景学习"、"虚拟搭建"，访问实验的
        <DocLink to="/info/goujians">构件认知学习模块</DocLink>、
        <DocLink to="/realitylearn">实景学习模块</DocLink>、
        <DocLink to="/virtuallearn">虚拟搭建实验</DocLink>三个模块
        ，点击"学习流程"，访问各模块的
        <DocLink to="/learn/step/1">操作引导与学习流程指南</DocLink>。
      </Paragraph>

      <Paragraph>
        <Text color="secondary">浏览器要求:</Text>
        浏览器使用Google Chrome
        64位版本，以获得最佳体验效果（76.0.3809.132正式版本64 位），
        <DocLink
          to="
                https://www.google.cn/chrome/
                
                "
          newpage
        >
          下载Chrome
        </DocLink>
        。
      </Paragraph>

      <Paragraph>
        <Text color="secondary">在线教学支持:</Text>
        本项目配备有在线教学服务团队，使用中有任何问题或反馈意见，请点击本页面右下角在线咨询按钮，前往我们的
        在线教学支持服务页面，可通过
        <DocLink to={onlineSupportRoot} newpage>
          在线咨询
        </DocLink>
        或
        <DocLink to={`${onlineSupportRoot}/feedback/`} newpage>
          邮件留言
        </DocLink>
        的方式获取服务支持。
      </Paragraph>
    </>
  );
};
//快速实验通道
const QuickTestPanel = (props) => {
  return (
    <>
      <Paragraph>
        <Text>快速前往</Text>
        <Text color="secondary">
          <DocLink to="/info/test">构件辨识实验</DocLink>、
          <DocLink to="/virtuallearn">虚拟搭建实验</DocLink>
        </Text>
        <Text>
          (包含平身科搭建实验、柱额层搭建实验、斗栱层搭建实验、屋架层搭建实验、椽望层搭建实验)
        </Text>
      </Paragraph>
    </>
  );
};

//实验概述
const BackGroundPanel = (props) => {
  return (
    <TabWithContent
      content={[
        {
          title: "实验项目背景",
          detail: (
            <>
              <Paragraph>
                清代官式建筑是指工部或内务府派员监督建造，包括北京的宫殿、坛庙、仓库、城垣、寺庙、王府等建筑，以及在北京以外敕建建筑，具有体系严密、术语规范、工艺多样统一的特点，代表了当时建筑发展的最高水平。大木作，最早见于宋代李诫《营造法式》，其中将建筑的木料工程分为大木作和小木作两大类，凡与建筑整体骨干构架有关的木构件均归入大木作范围。清官式大木作即清代官式建筑营造中与建筑整体骨干构架有关部分。{" "}
              </Paragraph>
              <Paragraph>
                北京大学考古文博学院下设有考古学、博物馆学、文物保护、文物建筑四个本科生专业方向。清官式大木作教学内容是文物建筑专业课程体系重要的组成部分，在《中国建筑史》课程中讲授，是学生后续进行深入的文物建筑研究、建筑考古研究的知识基础。
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}background/kechengtixi.jpg`} />
              <Paragraph>
                考古文博学院下设的考古学专业方向学生，同样需要研究学习中国建筑史与传统建筑构造，了解清代官式建筑以及早期建筑的各部分构件及建筑组合构造方式，以便未来在考古遗址及包含仿木构建筑构件的古代墓葬的发掘研究中，能够辨认出土的建筑构件遗物，撰写考古报告并绘制构件图纸，著名考古学家宿白先生就曾亲自在考古系讲授《中国古建筑考古》课程。例如下图白沙宋墓墓室内包含的大量建筑仿木构构件，考古专业学生如果未掌握中国古代建筑构造基本知识，则难以认知墓葬形制和结构；
              </Paragraph>
              <DocImage
                imageSrc={`${imageFolder}background/baishasongmu.jpg`}
              />
              <Paragraph>
                综上所述，《中国建筑史》的学习对于文物建筑与考古学专业的学生非常重要，而其中基础性的清官式大木作教学则是学生学习传统建筑构造的开端，其内容丰富、专业术语多，立体性强，需结合实物教学。因此我们开发了清官式大木作虚拟仿真教学实验，通过虚拟仿真技术提高教学效果，解决传统教学中存在的一系列问题。{" "}
              </Paragraph>
            </>
          ),
        },
        {
          title: "实验内容",
          detail: (
            <>
              <Paragraph>
                清官式大木作教学的主要内容分为四部分，分别为构件认知教学、清官式建筑构造教学、古建筑现场认知踏查、营造文献阅读与整理。本实验项目从教学内容出发，针对传统教学中面临的教学资源直观性差、实物模型数量少精度低学术性差无法满足搭建需求、现场踏查成本高有风险等教学痛点，设计了本实验项目，包含如下几个模块：
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}background/structure.jpg`} />
              <Paragraph>
                <Text color="secondary">构件认知学习模块:</Text>
                提供基本的构件信息学习，可供学生自主学习各个构件，掌握清官式大木作基础知识；学生首先通过本模块学习各类清官式大木作构件的名称、位置、描述等基础信息，查看构件的图纸、照片、重要营造文献中对构件的记载，掌握清官式大木作的基础知识；并通过构件辨识实验检验自身学习成果，不断巩固基础知识。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">实景学习模块:</Text>
                实景教学资源多为在典型的清代官式建筑现场采集的实景内容，例如建筑实地全景漫游，学生即可通过互联网在线查看建筑实景情况，以便学生通过真实建筑实物中进一步认知在清官式建筑中的各类构件的位置样式，与构件认知学习模块的理论部分相辅相成，同时为后续建筑现场踏查实习做好准备，虚实结合。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">虚拟搭建模块:</Text>
                虚拟搭建模块：选取清雍正十二年（1734年）清朝工部颁布的《工程做法》中建筑、斗栱样例作为虚拟搭建对象，并参考梁思成先生《清式营造则例》、《清工部〈工程做法〉图解》等书，通过三维建模软件，制作高仿真度的模型，严谨地再现清代官式大木建筑的风貌。实验包括平身科与歇山大木虚拟搭建两个搭建场景，通过这两个搭建场景，可以囊括清官式大木作的绝大部分构件与知识点；共包括平身科搭建实验、柱额层搭建实验、斗栱层搭建实验、屋架层搭建实验、椽望层搭建实验五个子实验，每个部分均提供测试模式、教学模式、查看模式，方便学生自主学习、自主测试；学生在对构件基础知识熟练掌握的基础上，进一步通过此模块的学习，动手实践一整座清代官式建筑大木作部分的完整建造过程，最终熟练掌握清代官式建筑构造。
              </Paragraph>

              <Paragraph>
                依托以上三个模块，本项目提供六个可供交互操作的实验，包括构件辨识实验、平身科搭建实验、柱额层搭建实验、斗栱层搭建实验、屋架层搭建实验、椽望层搭建实验；
              </Paragraph>
              <Paragraph>
                <Text color="secondary">清官式大木作教学资源库:</Text>
                教学资源库是整个实验项目的数据支撑，资源库设计架构如下图，学生在熟练掌握清官式大木作基础知识与建筑构造后，即可通过自主踏查文物建筑拍摄建筑构件照片、阅读清官式营造文献整理文献内容，将研究学习的成果在线加入教学资源库，提升学生自主学习研究积极性，同时保障教学资源库的持续建设。
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}background/ziyuanku.jpg`} />
            </>
          ),
        },

        {
          title: "实验对象与目的",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">:</Text>
                因本实验属于历史类虚拟仿真实验项目，未开设实验类课程，项目配合北京大学考古文博学院开设的以下四门课程的教学使用，其中《中国建筑史》为本项目核心应用课程。
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}background/courses.jpg`} />
              <Paragraph>
                实验项目提供学习清官式大木作的全流程教学资源与虚拟实验，实验内容循序渐进，由浅入深，可供不同基础的学生、不同教学程度、不同学科的课程使用(例如文物建筑、考古学、文化遗产等多个专业方向)。
              </Paragraph>
              <Paragraph>
                学生可根据自身知识水平，希望达到的学习效果，选择合适的模块进行学习；教师也可根据自身课程的侧重点，选择不同的模块配合教学使用。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">本实验为达到如下教学目的:</Text>
              </Paragraph>
              <Paragraph>
                1、掌握清官式大木作构件的名称、位置、权衡、功能；
              </Paragraph>
              <Paragraph>
                2、掌握清官式斗栱组合搭建方式，完成平身科斗栱的虚拟搭建。
              </Paragraph>
              <Paragraph>
                3、掌握清官式建筑整体组合搭建方式，完成一整座清官式歇山建筑大木作的虚拟搭建。
              </Paragraph>
              <Paragraph>
                4、熟悉清官式大木作构件在重要营造文献及相关著作中的记载与阐释；
              </Paragraph>
              <Paragraph>
                5、熟悉现场踏查古建筑时认知建筑的方法，能够辨认并记录古建筑实物上的各个大木作构件；
              </Paragraph>
              <Paragraph>
                6、引导学生对清官式建筑相关营造文献进行阅读与研究。
              </Paragraph>
            </>
          ),
        },
      ]}
    />
  );
};

//系统介绍
const DocPanel = (props) => {
  return (
    <TabWithContent
      content={[
        {
          title: "系统概况",
          detail: (
            <>
              <Paragraph>
                本教学系统以《中国建筑史》（本科生专业必修课）、《传统建筑构造》（本科生专业必修课）、《中国建筑技术史专题》（研究生限选课）、《营造学社与中国建筑》（元培新生讨论课）课程中关于清官式大木作部分的教学内容为出发点制作；
                便于学生直观的理解与学习较为抽象的清官式大木作术语，认知构件在真实建筑中的位置，了解营造文献中对于构件做法的描述，现场考察并认知真实的清代官式建筑，同时培养学生学习兴趣，为学生日后进一步深入研究清官式建筑打下基础。
              </Paragraph>
              <Paragraph>
                本教学系统为一个大型综合性教学系统，包含三个子模块，分别为构件信息学习模块、实景学习模块、虚拟搭建实验三部分。
              </Paragraph>
            </>
          ),
        },
        {
          title: "系统内容",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">构件学习模块:</Text>
                构件学习模块提供基本的构件信息学习，可供学生自主学习各个构件，掌握清官式大木作基础知识。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">实景学习模块:</Text>
                实景学习模块包括教师上传的一些列实景教学资源，目的是为了辅助学生认知在真实的清官式建筑中的各类构件的位置样式，与构件学习模块的理论部分相辅相成，虚实结合。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">虚拟搭建模块:</Text>
                虚拟搭建模块提供平身科虚拟搭建与歇山大木虚拟搭建两个试验，使用清雍正十二年（1734年）清朝工部颁布的《工程做法》中建筑样例、斗栱样例作为虚拟搭建对象，并参考梁思成先生《清式营造则例》、《清工部〈工程做法〉图解》、马炳坚《中国古建筑木作营造技术》等书，以期严谨地再现清代官式大木建筑的风貌，学生通过此模块的学习，让深入了解并实践一座清代官式建筑大木作部分的完整建造过程，最终熟练掌握清代官式建筑的构造。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">可交互实验:</Text>
                依托以上三个模块，本系统共提供六个可供交互操作的实验，包括构件辨识实验、平身科搭建实验、柱额层搭建实验、斗栱层搭建实验、屋架层搭建实验、椽望层搭建实验，六个实验均记录学生测试使用的成绩，并且教师可在实验成绩管理模块查看学生使用记录及成绩统计信息，为有针对性的教学提供支撑。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">数据库建设:</Text>
                本教学系统的教学信息数据库，除了为教学提供数据支持外，同时也向学生开放清式营造条文与图纸照片的编辑功能，学生自主研读营造文献并现场考察清官式建筑，将提炼出的构件做法的文献加入条文列表中，将现场拍摄的构件照片加入图片列表中，成为数据库的内容建设者。
              </Paragraph>
              <Paragraph>
                各模块的详细使用文档及内容参见
                <DocLink to="/learn/step/2/">学习流程页面</DocLink>
              </Paragraph>
            </>
          ),
        },

        {
          title: "教学创新",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">清官式大木作信息数据库:</Text>
                系统整合各类教学资源，建立了清官式大木作构件信息库，数据库提供了清官式大木作基本构件信息、清官式大木作营造文献信息、大木作构件图纸照片信息、大木作构件营造条文信息四部分内容。既满足了基本的教学信息的存储，并且提供方便的扩展性，同时依托数据库制作方便学生在线学习、查看、测试的构件信息学习模块；数据库内容可通过提供的API增删改查，比仅仅使用传统的固定的教学资源更加灵活，确保了整个教学系统内容的持续更新，实现了教学内容与教学形式的分离，未来即使改变新的教学形式，这些教学资源同于可以延续使用，甚至为其他项目提供数据支持。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">实景学习资源整合:</Text>
                整合各类实景学习资源，供学生在线上认知真实建筑中的构件情况，以虚拟仿真的形式复现现场考察古建筑的教学内容，为学生实地做建筑调查打下基础，实景资源不限制形式，任意以网上链接存在的资源均可使用，对于充分整合利用已有虚拟教学资源避免二次开发起到重要作用。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">虚拟搭建实验:</Text>
                虚拟搭建实验别开生面，让学生通过实践操作，能动性的认知清官式建筑的构造，教学效果比传统的口头讲述，指认构件有很大提升，同时有助于提升学生的学习兴趣。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">教学资源建设:</Text>
                系统开放数据库建设作为一部分教学内容，让学生成为数据库的建设者，学生不再仅仅被动是使用教学资源，而是成为教学资源的建设者，充分调动学生的积极性，同时确保了教学资源可持续建设
              </Paragraph>
              <Paragraph>
                <Text color="secondary">数据库持续建设:</Text>
                本教学系统的教学信息数据库，除了为教学提供数据支持外，同时也向学生开放清式营造条文与图纸照片的编辑功能，学生自主研读营造文献并现场考察清官式建筑，将提炼出的构件做法的文献加入条文列表中，将现场拍摄的构件照片加入图片列表中，成为数据库的内容建设者。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">成绩分析统计:</Text>
                系统包含成绩分析模块，教师可以查看学生的使用情况，了解学生使用的困难，做到了教学效果的在线可视化，既可以供学生分析自身的学习效果，也可供教师针对学生学习情况，进行有针对性的教学。
              </Paragraph>
            </>
          ),
        },
      ]}
    />
  );
};

//团队介绍文档
const GroupPanel = (props) => {
  return (
    <TabWithContent
      content={[
        {
          title: "团队成员",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">张剑葳:</Text>
                北京大学考古文博学院院长、考古虚拟仿真实验教学中心副主任、助理教授
              </Paragraph>
              <Paragraph>
                <Text color="secondary">吴煜楠:</Text>
                北京大学考古虚拟仿真实验教学中心工程师
              </Paragraph>
              <Paragraph>
                <Text color="secondary">尚劲宇:</Text>
                北京大学考古虚拟仿真实验教学中心工程师
              </Paragraph>
              <Paragraph>
                <Text color="secondary">王一臻:</Text>
                北京大学考古文本学院硕士毕业生
              </Paragraph>
            </>
          ),
        },
        {
          title: "团队分工",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">系统功能总体设计策划:</Text>
                张剑葳、吴煜楠、尚劲宇、
              </Paragraph>
              <Paragraph>
                <Text color="secondary">系统网站功能设计:</Text>
                张剑葳、吴煜楠、王一臻、尚劲宇
              </Paragraph>

              <Paragraph>
                <Text color="secondary">教学资源数据库架构设计:</Text>
                张剑葳、吴煜楠、尚劲宇、王一臻
              </Paragraph>

              <Paragraph>
                <Text color="secondary">虚拟搭建软件功能设计:</Text>
                王一臻、吴煜楠、张剑葳、尚劲宇
              </Paragraph>

              <Paragraph>
                <Text color="secondary">教学数据、模型制作:</Text>
                王一臻、吴煜楠、张剑葳、尚劲宇
              </Paragraph>

              <Paragraph>
                <Text color="secondary">后端API实现:</Text>
                吴煜楠
              </Paragraph>

              <Paragraph>
                <Text color="secondary">前端网页实现:</Text>
                吴煜楠
              </Paragraph>

              <Paragraph>
                <Text color="secondary">虚拟拼装Unity程序实现:</Text>
                王一臻
              </Paragraph>

              <Paragraph>
                <Text color="secondary">网站运维:</Text>
                吴煜楠
              </Paragraph>
              <Paragraph>
                <Text color="secondary">系统功能测试:</Text>
                张剑葳、吴煜楠、王一臻、尚劲宇
              </Paragraph>
            </>
          ),
        },
      ]}
    />
  );
};

//技术介绍文档
const TechPanel = (props) => {
  return (
    <TabWithContent
      content={[
        {
          title: "使用环境",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">使用硬件要求:</Text>
                使用虚拟搭建实验时，需要配合分辨率比例为16:9的显示器使用，并配备鼠标、键盘等输入设备，方便在3D场景内进行交互。
                虚拟搭建实验模块涉及3D渲染，建议使用带有独立显卡的电脑使用以获得流程体验，其它不涉及3D渲染部分的内容，普通上网本即可正常使用。
              </Paragraph>
              <Paragraph>
                <Text color="secondary">使用软件要求:</Text>
                浏览器使用Google Chrome
                64位版本，以获得最佳体验效果，（76.0.3809.132正式版本64 位），
                <DocLink
                  to="
                https://www.google.cn/chrome/
                
                "
                  newpage
                >
                  去官网下载Chrome
                </DocLink>
              </Paragraph>
              <Paragraph>
                <Text color="secondary">使用网络要求:</Text>
                部分教学数据量较大，例如unity3D场景、高清图片等，建议在网络条件较好的情况的下使用，推荐5M及以上带宽进行使用，以获得流程加载体验。
              </Paragraph>
            </>
          ),
        },
        {
          title: "技术架构",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">前端:</Text>
                React框架，MaterialUI实现UI设计，所用到的其他插件包括ReachRouter、redux，notistack、react-3d-viewer、react-grid-gallery、react-iframe、react-material-ui-form-validator、recharts、threeJS，均为开源软件
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}techlogo/01.jpg`} />

              <Paragraph>
                <Text color="secondary">后端:</Text>
                Django，DRF(Django REST framework)提供RESTful API服务
              </Paragraph>

              <Paragraph>
                <Text color="secondary">数据库:</Text>
                使用MariaDB(MySQL社区开源版)存储教学资源数据
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}techlogo/02.jpg`} />

              <Paragraph>
                <Text color="secondary">虚拟搭建软件:</Text>
                虚拟搭建软件开发主要依靠Unity3d引擎。建模软件为Rhino5.0和Maya，材质纹理依靠Substance
                painter，美工设计使用Photoshop，完成开发后发布为网页版在线使用
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}techlogo/03.jpg`} />
            </>
          ),
        },
      ]}
    />
  );
};

// Panel方式交互展示文档
const resourcesPanelContent = [
  {
    panelTitle: <Text color="primary">评审账号</Text>,
    panelDetail: <AccountPanel />,
  },
  {
    panelTitle: <Text color="primary">快速实验入口</Text>,
    panelDetail: <QuickTestPanel />,
  },
  {
    panelTitle: <Text color="primary">实验概述</Text>,
    panelDetail: <BackGroundPanel />,
  },
  {
    panelTitle: <Text color="primary">使用环境与技术架构</Text>,
    panelDetail: <TechPanel />,
  },
  {
    panelTitle: <Text color="primary">实验简介视频</Text>,
    panelDetail: <IntroVideo videoUrl="/videos/3min.mp4" />,
  },
  // {
  //   panelTitle: <Text color="primary">实验引导视频</Text>,
  //   panelDetail: <IntroVideo videoUrl="/videos/6min.mp4" />
  // }
];

//在线服务Fab
function FabButton(props) {
  const classes = useStyles();
  return (
    <Fab
      variant="extended"
      color="primary"
      aria-label="教学服务支持"
      className={classes.fab}
      onClick={() => window.open("http://qgssupport.pkugujian.com/")}
    >
      <SvgIcon>
        <path d="M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z" />
      </SvgIcon>
      在线咨询
    </Fab>
  );
}

//Main Component
function Introduction(props) {
  return (
    <>
      <DocPaper>
        <Title>清官式大木作虚拟仿真教学实验</Title>
        {resourcesPanelContent.map(({ panelTitle, panelDetail }, index) => (
          <Panel
            panelTitle={panelTitle}
            panelDetail={panelDetail}
            key={index}
            defaultOpen={index <= 2}
          />
        ))}
      </DocPaper>
      <FabButton />
    </>
  );
}

export default Introduction;
